import type { FunctionComponent } from "react";

import { HeaderMenuItem } from "scmp-app/components/posties/header/common/header-menu-item";

import { postiesMenuData } from "./data";
import { Container } from "./styles";

export type Props = {
  className?: string;
};

export const HeaderMenu: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    {postiesMenuData.map((item, index) => (
      <HeaderMenuItem
        hash={item.hash}
        key={index}
        name={item.name}
        pathname={item.urlAlias}
        query={item.query}
      />
    ))}
  </Container>
);

HeaderMenu.displayName = "HeaderMenu";
